<app-header></app-header>
<app-leftsidebar [activePath]="activePath"></app-leftsidebar>

<div class="cp-main-sec">
  <div class="right-sec">
    <div class="cport-right-sec">

      <div class="chp-head">
        <div class="chp-head-text">
          <h1>Character <span class="gold">Portfolio</span></h1>
          <p>
            Manage character details, backstories, inventory and portraits.
            Track status and jump into any game.
          </p>
        </div>
        <button class="btn btn-theme" (click)="addnewplayer()" [disabled]="disablebtn">
          New character
        </button>
      </div>

      <div class="chp-toolbar">
        <div class="chp-tabs" role="tablist">
          <button role="tab" [attr.aria-selected]="selectedTab === 'active'" (click)="selectedTab = 'active'">
            Active <span class="chp-count">{{ (activeCharData || []).length }}</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'retired'" (click)="selectedTab = 'retired'">
            Retired <span class="chp-count">{{ retiredCharacters.length }}</span>
          </button>
          <button role="tab" [attr.aria-selected]="selectedTab === 'dead'" (click)="selectedTab = 'dead'">
            Dead <span class="chp-count">{{ deadCharacters.length }}</span>
          </button>
        </div>
        <div class="chp-view-toggle" role="group" aria-label="View" *ngIf="!isMobile">
          <button [attr.aria-pressed]="viewMode === 'cards'" (click)="setViewMode('cards')">Cards</button>
          <button [attr.aria-pressed]="viewMode === 'rows'" (click)="setViewMode('rows')">Rows</button>
        </div>
      </div>

      <p class="chp-help" [ngSwitch]="selectedTab">
        <ng-container *ngSwitchCase="'active'">Active characters can be played in any game you're seated in.</ng-container>
        <ng-container *ngSwitchCase="'retired'">Retired characters become NPCs — their sheet and history are preserved, but they're no longer playable.</ng-container>
        <ng-container *ngSwitchDefault>Deceased characters are read-only — the sheet and history remain for reference.</ng-container>
      </p>

      <div class="chp-grid" [class.is-rows]="viewMode === 'rows'">
        <ng-container *ngFor="let item of visibleChars">
          <ng-container *ngTemplateOutlet="charCard; context: { $implicit: item }"></ng-container>
        </ng-container>

        <!-- add / limit -->
        <ng-container *ngIf="selectedTab === 'active'">
          <button *ngIf="!isButtonDisabled(); else limitReached" class="chp-add" (click)="addnewplayer()"
            [disabled]="disablebtn">
            <span class="chp-add-plus">+</span>
            <span class="chp-add-label">New character</span>
            <span class="chp-add-sub">Roll up someone new — sheet, portrait, backstory.</span>
          </button>
          <ng-template #limitReached>
            <div class="chp-limit">
              <span>You've reached your active / retired character limit. Subscribe for more slots.</span>
              <button class="btn btn-green" [routerLink]="['/subscription']" [queryParams]="{ isUser: true }">
                Subscribe
              </button>
            </div>
          </ng-template>
        </ng-container>

        <div class="chp-limit" *ngIf="selectedTab === 'retired' && shouldLimitReachedRetried()">
          <span>You've reached your active / retired character limit. Subscribe for more slots.</span>
          <button class="btn btn-green" [routerLink]="['/subscription']" [queryParams]="{ isUser: true }">
            Subscribe
          </button>
        </div>

        <p class="chp-empty" *ngIf="visibleChars.length === 0 && selectedTab !== 'active'">
          No {{ selectedTab }} characters.
        </p>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>

<!-- ===================== one card, reused across tabs ===================== -->
<ng-template #charCard let-item>
  <article class="chp-card" [attr.data-status]="charStatus(item)">
    <div class="chp-card-top">
      <button type="button" class="chp-portrait" (click)="imguploadopenmodel(item)" aria-label="Change portrait">
        <img [src]="item.cropped_image ? imageurl + item.cropped_image : 'assets/main/OIP.jpg'" alt="" />
      </button>
      <div class="chp-card-id">
        <span class="chp-pill" [attr.data-status]="charStatus(item)">{{ charStatusLabel(item) }}</span>
        <h3 class="chp-name" (click)="editplayerdetail(item)">{{ item.nickname }}</h3>
        <p class="chp-meta">
          Lvl {{ item.primary_class_level || '—' }} · {{ item.race || 'Unknown' }} ·
          {{ item.primary_class || 'Adventurer' }} · {{ item.alignment || 'True Neutral' }}
        </p>
      </div>
    </div>

    <div class="chp-stats">
      <div class="chp-stat"><span class="k">Str</span><span class="v">{{ item.strength || '–' }}</span></div>
      <div class="chp-stat"><span class="k">Dex</span><span class="v">{{ item.dexterity || item.Dexterity || '–' }}</span></div>
      <div class="chp-stat"><span class="k">Con</span><span class="v">{{ item.constitution || '–' }}</span></div>
      <div class="chp-stat"><span class="k">Wis</span><span class="v">{{ item.wisdom || item.wisdon || '–' }}</span></div>
      <div class="chp-stat"><span class="k">Int</span><span class="v">{{ item.intelligence || '–' }}</span></div>
      <div class="chp-stat"><span class="k">Cha</span><span class="v">{{ item.charisma || '–' }}</span></div>
    </div>

    <p class="chp-loc">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
        <path d="M6 21V4M6 4l9 3-3 4 6 2-12 4" />
      </svg>
      {{ charLocation(item) }}
    </p>

    <div class="chp-card-actions">
      <button class="btn btn-green"
        [disabled]="!canPlay(item)"
        [title]="canPlay(item) ? '' : 'Place this character on a map first'"
        (click)="playgame(item)">
        {{ selectedTab === 'active' ? 'Play' : 'View' }}
      </button>
      <button *ngIf="selectedTab === 'active'" class="btn btn-outline" (click)="editplayerdetail(item)">
        Sheet
      </button>
    </div>
  </article>
</ng-template>
